export const notificationConstants = {
  GET_NOTIFICATIONS_STARTED: 'GET_NOTIFICATIONS_STARTED',
  GET_NOTIFICATIONS_SUCCESS: 'GET_NOTIFICATIONS_SUCCESS',
  GET_NOTIFICATIONS_FAILURE: 'GET_NOTIFICATIONS_FAILURE',

  READ_NOTIFICATIONS_STARTED: 'READ_NOTIFICATIONS_STARTED',
  READ_NOTIFICATIONS_SUCCESS: 'READ_NOTIFICATIONS_SUCCESS',
  READ_NOTIFICATIONS_FAILURE: 'READ_NOTIFICATIONS_FAILURE',
};
